export type UIPreferences = {
  showCredits: boolean;
};

export const DEFAULT_UI_PREFERENCES: UIPreferences = {
  showCredits: true,
};

export const UI_PREFERENCES_STORAGE_KEY = 'v1:ui-preferences';
